import { useTranslation } from 'react-i18next';

const STYLES: Record<string, string> = {
  PENDING: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  APPROVED: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-200',
  REJECTED: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
  RETURNED: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-200',
  ESCALATED: 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-200',
  DELEGATED: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
  CANCELLED: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300',
};

interface Props {
  status: string;
}

export function ApprovalStatusBadge({ status }: Props) {
  const { t } = useTranslation('workflow');
  const normalized = status.toUpperCase();
  const style = STYLES[normalized] ?? 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300';
  const label = t(`status.${normalized.toLowerCase()}`, { defaultValue: status.replace(/_/g, ' ') });
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${style}`}>
      {label}
    </span>
  );
}
